import ReactGA from 'react-ga';

ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID, {
  gaOptions:{
    anonymizeIp:true
  }
});

const track = (action)=>{
  if(process.env.REACT_APP_ENV==="PRODUCTION"){
    // window.mixpanel.track(action)
    // ReactGA.event({
    //   category:"user",
    //   action
    // });
  }else{
    console.log("[DEV] logged event", {action})
  }
}
const set = (obj)=>{
  if(process.env.REACT_APP_ENV==="PRODUCTION"){
    //window.mixpanel.people.set(obj);
  }else{
    console.log("[DEV] set Object", obj)
  }
}
const registerUser=(user)=>{
  if(process.env.REACT_APP_ENV==="PRODUCTION"){
    // window.mixpanel.identify(user.id);
    // set({
    //   "$email": user.email,    // only special properties need the $
    //   "$created": user.createdAt,
    //   "$last_login": new Date(),         // properties can be dates...
    //   "facebook": user.facebook,                    // ...or numbers
    //   "name":user.name,
    //   // "subscription_plan":user.subscription.plan,
    //   // "subscription_end":user.subscription.willEndAt,
    //   // "subscription_active":user.subscription.active
    // });
  }else{
    console.log("[DEV] registeredUser", user)
  }
}
const init=(history)=>{
  if(process.env.REACT_APP_ENV==="PRODUCTION"){
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
    history.listen((location, action) => {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    });
  }else{
    history.listen((location, action) => {
      console.log("[DEV] logged pageview", location.pathname)
    });
  }

}


export default {
  registerUser,
  set,
  track,
  init
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js